import type { LiaConclusion, LiaValidationStatus, UpdateLiaInput } from './lia.types';

const isBlank = (value: string) => !value.trim();

export type LiaCompletenessItem = {
  id: string;
  complete: boolean;
};

export const isSupportingConclusion = (conclusion: LiaConclusion | ''): boolean =>
  conclusion === 'legitimate_interest_supported' || conclusion === 'legitimate_interest_supported_with_safeguards';

export const calculateLiaCompleteness = (input: UpdateLiaInput): LiaCompletenessItem[] => [
  { id: 'necessity_assessment', complete: !isBlank(input.necessityAssessment) },
  { id: 'balancing_assessment', complete: !isBlank(input.balancingAssessment) },
  { id: 'safeguards_description', complete: !isBlank(input.safeguardsDescription) },
  { id: 'right_to_object_handling', complete: !isBlank(input.rightToObjectHandling) },
  { id: 'conclusion', complete: Boolean(input.conclusion) },
  { id: 'conclusion_comment', complete: !isBlank(input.conclusionComment) },
  {
    id: 'vulnerable_data_subjects_comment',
    complete: !input.vulnerableDataSubjectsInvolved || !isBlank(input.vulnerableDataSubjectsComment),
  },
];

export const isLiaComplete = (input: UpdateLiaInput): boolean => calculateLiaCompleteness(input).every(item => item.complete);

export const calculateLiaValidationStatus = (input: UpdateLiaInput, isDeleted: boolean): LiaValidationStatus => {
  if (isDeleted) return 'invalid';
  if (!isLiaComplete(input)) return 'invalid';
  if (!isSupportingConclusion(input.conclusion)) return 'invalid';
  return 'valid';
};
